module.exports = __webpack_public_path__ + "static/info-a46e4aa56a2a05326cbc3c17af536dfe.png";